var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { removeFromWhitelist } from 'src/utils/preferences.utils';
const AuthorizedOperations = ({ activeAccount, setTitleContainerProperties, }) => {
    const [noConfirm, setNoConfirm] = useState({});
    const [websites, setWebsites] = useState({});
    const [filterWebSites, setFilterWebSites] = useState({});
    const [filterValue, setFilterValue] = useState('');
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_operations',
            isBackButtonEnabled: true,
        });
        init();
    }, []);
    useEffect(() => {
        if (noConfirm) {
            setWebsites(noConfirm[activeAccount.name]);
            setFilterWebSites(noConfirm[activeAccount.name]);
        }
    }, [activeAccount, noConfirm]);
    useEffect(() => {
        handleOnChangeFilter(filterValue);
    }, [filterValue]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        let res = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_CONFIRM);
        setNoConfirm(res);
    });
    const handleEraseButtonClick = (website, operation) => {
        const newList = removeFromWhitelist(Object.assign({}, noConfirm), activeAccount.name, website, operation);
        setNoConfirm(newList);
    };
    const handleOnChangeFilter = (valueToFilter) => {
        const filtered = {};
        const lowerCaseValueToFilter = valueToFilter.toLowerCase();
        for (const [website, operations] of Object.entries(websites)) {
            if (website.toLowerCase().includes(lowerCaseValueToFilter)) {
                filtered[website] = operations;
            }
            else {
                const op = Object.entries(operations).find((operation) => {
                    const readableOperation = getMessage(`popup_${operation[0]
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase()}`);
                    if (operation[0].toLowerCase().includes(lowerCaseValueToFilter) ||
                        readableOperation.toLowerCase().includes(lowerCaseValueToFilter)) {
                        return true;
                    }
                });
                if (op) {
                    filtered[website] = { [op[0]]: op[1] };
                }
            }
        }
        setFilterWebSites(filtered);
    };
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_AUTHORIZED_OPERATIONS}-page`, className: "authorized-operations-page" },
        React.createElement("div", { className: "introduction" }, getMessage('popup_html_pref_info')),
        React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
        websites && Object.keys(websites).length > 0 && (React.createElement(InputComponent, { dataTestId: "input-filter-box", type: InputType.TEXT, placeholder: "popup_html_search", logo: SVGIcons.INPUT_SEARCH, logoPosition: "right", value: filterValue, onChange: (value) => setFilterValue(value) })),
        filterWebSites && Object.keys(filterWebSites).length > 0 && (React.createElement("div", { className: "preferences" }, Object.keys(filterWebSites).map((website) => Object.keys(filterWebSites[website]).map((operation) => {
            return (websites[website][operation] && (React.createElement("div", { "data-testid": 'whitelisted-operation-item', className: "operation", key: operation },
                React.createElement("div", { className: "left-panel" },
                    React.createElement("div", { className: "website" }, website),
                    React.createElement("div", { className: "operation-name" }, getMessage(`popup_${operation
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase()}`))),
                React.createElement(SVGIcon, { dataTestId: `icon-delete-authorized-${operation}-${website}`, onClick: () => handleEraseButtonClick(website, operation), icon: SVGIcons.GLOBAL_DELETE, className: "operation-action" }))));
        })))),
        (filterWebSites && Object.keys(filterWebSites).length === 0) ||
            (!filterWebSites && (React.createElement("div", { className: "no_pref" }, getMessage('popup_html_no_pref')))),
        filterValue.trim().length > 0 &&
            Object.keys(filterWebSites).length === 0 && (React.createElement("div", { className: "no_pref" }, getMessage('popup_html_nothing_found_using_filter')))));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, { setTitleContainerProperties });
export const AuthorizedOperationsComponent = connector(AuthorizedOperations);
